import v2 from './v2';
import v3 from './v3';
import v4 from './v4';
import v5 from './v5';
import v6 from './v6';
import v7 from './v7';
import v8 from './v8';
import v9 from './v9';
import v10 from './v10';
import latestReleases from './latestReleases';

const mapper = {
  2: (params) => v2({ ...params, updateVersion: 2 }),
  3: (params) => v3({ ...params, updateVersion: 3 }),
  4: (params) => v4({ ...params, updateVersion: 4 }),
  5: (params) => v5({ ...params, updateVersion: 5 }),
  6: (params) => v6({ ...params, updateVersion: 6 }),
  7: (params) => v7({ ...params, updateVersion: 7 }),
  8: (params) => v8({ ...params, updateVersion: 8 }),
  9: (params) => v9({ ...params, updateVersion: 9 }),
  10: (params) => v10({ ...params, updateVersion: 10 }),
};

export default (params) => {
  const { fieldType, currentVersion } = params;
  const targetRelease = latestReleases[fieldType];

  const currVersion = currentVersion ? currentVersion.number : 1;

  let { fieldData, userPreferences } = params;
  for (let i = currVersion + 1; i <= targetRelease; i) {
    if (targetRelease) {
      const mapperData = mapper[i]({ ...params, fieldData });
      let updatedData = fieldData;
      if (mapperData) {
        ({ [fieldType]: updatedData } = mapperData);
      }
      fieldData = updatedData;

      if (userPreferences) {
        const updatedDataUserPreferences = mapper[i]({
          ...params,
          userPreferences,
        });
        userPreferences = updatedDataUserPreferences;
      }
    }
    i += 1;
  }

  return { [fieldType]: fieldData || userPreferences };
};
